import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { RouterModule } from "@angular/router";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { MatIconModule } from "@angular/material/icon";
import { MatLegacyButtonModule as MatButtonModule } from "@angular/material/legacy-button";
import { AccessLinkComponent } from "./access-link.component";

@NgModule({
  declarations: [
    AccessLinkComponent
  ],
  imports: [
    CommonModule,
    MatProgressSpinnerModule,
    MatIconModule,
    MatButtonModule,
    RouterModule.forChild([
      {
        path: "",
        component: AccessLinkComponent
      }
    ])
  ],
  exports: [
    AccessLinkComponent
  ]
})
export class AccessLinkModule {}
